import React, { useState } from 'react'

import { Card, Row, Col, Button, Rate, Table, Divider, InputNumber } from 'antd'

import { saveRating } from '../../helpers/meetings/saveRating';


const Rating = ({ dataRating, quarterly, meetingDate, setLoadDataRating, dataRatingEdit, setDataRatingEdit, prom, setProm, setShowAlertRating, setOptionAlert }) => {


    const handleRatingChange = (value, id) => {
        const newData = [...dataRatingEdit];
        const index = newData.findIndex((item) => item.id === id);
        if (index !== -1) {
            newData[index].rating = value;
        } else {
            newData.push({ id: id, rating: value });
        }

        // let total = 0;

        // newData.forEach(item => {
        //     total += item.rating;
        // });

        // setProm((total / newData.length).toFixed(1));
        setDataRatingEdit(newData);
    }

    const handleSaveRating = () => {
        if (quarterly && meetingDate && dataRatingEdit.length > 0) {
            saveRating(dataRatingEdit, quarterly, meetingDate).then((response) => {
                if (response.status === "success") {
                    setShowAlertRating(true);
                    setOptionAlert({
                        message: "Calificaciones guardadas",
                        description: "Las calificaciones se han guardado correctamente.",
                        type: "success"
                    });
                    setLoadDataRating(true);
                }
            });
        }
    }

    const columnsRating = [
        {
            title: 'Usuario',
            dataIndex: 'username',
            key: 'username',
            width: 100,
            render: (_, record) => {
                return <p>{record.username}</p>;
            }
        },
        {
            title: 'Calificación',
            dataIndex: 'rating',
            key: 'rating',
            width: 100,
            render: (text, record) => <InputNumber min={1} max={10} defaultValue={text} onChange={(value) => handleRatingChange(value, record.id)} />,
        }
    ];

    return (
        <div style={{ margin: "0 12px" }}>
            <Row gutter={16} style={{ marginBottom: "12px" }}>
                <Col span={18}>
                    <h3 style={{ fontSize: "18px", margin: 0 }}>Evaluación de la reunión | Grupo Optima</h3>
                    <p style={{ fontSize: "16px", color: "gray" }}>Calificación del Desempeño de Participantes</p>
                </Col>
            </Row>

            <Row style={{ justifyContent: "end", marginBottom: "12px" }}>
                <Col span={6} style={{ textAlign: "right" }}>
                    <Button type="primary" style={{ backgroundColor: '#00A310', border: 'none' }} onClick={handleSaveRating}>Guarda evaluación</Button>
                </Col>
            </Row>

            <Row style={{ marginBottom: "12px", justifyContent: "center" }}>
                <Col span={12}>
                    <h4 style={{ fontSize: "16px" }}>Calificaciones</h4>
                    <Table columns={columnsRating} dataSource={dataRating} pagination={false} />
                </Col>
                <Col span={12} style={{ marginTop: "20px", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card style={{ width: "50%", height: 100, textAlign: "center" }}>
                        <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>Promedio</h4>
                        <p>{prom}</p>
                    </Card>
                </Col>
            </Row>

            {/* <Row gutter={16} >
                {users.map((user) => (
                    <Col span={12} key={user.id}>
                        <Card>
                            <h4 style={{ fontSize: "16px", margin: 0 }}>{user.name} {user.lastname}</h4>
                            <InputNumber value={dataRatingEdit.find(o => o.id === user.id)?.rating ?? user.rating} style={{ fontSize: "24px" }} onChange={(value) => handleatingChange(value, user.id)} />
                        </Card>
                    </Col>
                ))}
            </Row> */}
        </div>
    )
}

export default Rating